module.exports = __webpack_public_path__ + "static/img/head-id.368432fc.webp";